import * as React from "react";
import { Card, IconButton, Price } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
/* empty css                 */
const ProductItem = ({ product, onRemove, labels }) => {
  const { slug, sku, name, price } = product;
  const image = product.image ? {
    src: product.image.url + "?fit=fillmax&fm=jpeg&w=352&h=256&auto=format",
    alt: product.image.label || name
  } : void 0;
  return /* @__PURE__ */ React.createElement(Card, { key: `${slug}-${sku}`, layout: "horizontal", className: "try-in-store-modal__product-item" }, /* @__PURE__ */ React.createElement(
    Card.Image,
    {
      src: image?.src || "",
      alt: image?.alt || "",
      className: "try-in-store-modal__product-item__image"
    }
  ), /* @__PURE__ */ React.createElement(Card.Content, { center: true, className: "try-in-store-modal__product-item__content" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: onRemove,
      className: "try-in-store-modal__product-item__remove",
      variant: "ghost",
      "aria-label": labels.remove
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  ), /* @__PURE__ */ React.createElement(Card.Heading, { variant: "subheading1", component: "h3" }, name), price.amount ? /* @__PURE__ */ React.createElement(Card.Text, null, /* @__PURE__ */ React.createElement(Price, { value: price.amount, currency: price.currencyCode, centAmount: false })) : null));
};
export {
  ProductItem
};
//# sourceMappingURL=ProductItem.js.map
